"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.one = exports.on = exports.closest = exports.matches = void 0;
require("element-closest");
function matches(el, selector) {
    if ('msMatchesSelector' in el) {
        return el.msMatchesSelector(selector);
    }
    else if ('matches' in el) {
        return el.matches(selector);
    }
    return false;
}
exports.matches = matches;
function closest(el, selector) {
    if (matches(el, selector)) {
        return el;
    }
    return el.closest(selector);
}
exports.closest = closest;
function on(event, selectorOrElement, fn) {
    var el = (typeof selectorOrElement === 'string') ? document.documentElement : selectorOrElement;
    if (typeof event === 'string') {
        el.addEventListener(event, function (e) {
            var listeningElement = e.target;
            if (e.target && typeof selectorOrElement === 'string') {
                listeningElement = closest(e.target, selectorOrElement);
            }
            else {
                listeningElement = el;
            }
            if (!!listeningElement) {
                fn(e, listeningElement);
            }
        });
    }
    else {
        event.forEach(function (evt) {
            el.addEventListener(evt, function (e) {
                var listeningElement = e.target;
                if (e.target && typeof selectorOrElement === 'string') {
                    listeningElement = closest(e.target, selectorOrElement);
                }
                else {
                    listeningElement = el;
                }
                if (!!listeningElement) {
                    fn(e, listeningElement);
                }
            });
        });
    }
}
exports.on = on;
function one(event, selectorOrElement, fn) {
    var el = (typeof selectorOrElement === 'string') ? document.documentElement : selectorOrElement;
    if (typeof event === 'string') {
        var f_1;
        el.addEventListener(event, f_1 = function (e) {
            var listeningElement = e.target;
            if (e.target && typeof selectorOrElement === 'string') {
                listeningElement = closest(e.target, selectorOrElement);
            }
            else {
                listeningElement = el;
            }
            if (!!listeningElement) {
                el.removeEventListener(event, f_1);
                fn(e, listeningElement);
            }
        });
    }
    else {
        event.forEach(function (evt) {
            var f;
            el.addEventListener(evt, f = function (e) {
                var listeningElement = e.target;
                if (e.target && typeof selectorOrElement === 'string') {
                    listeningElement = closest(e.target, selectorOrElement);
                }
                else {
                    listeningElement = el;
                }
                if (!!listeningElement) {
                    el.removeEventListener(evt, f);
                    fn(e, listeningElement);
                }
            });
        });
    }
}
exports.one = one;
